"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function LinkIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("rect", { x: "6.951", y: "11.15", width: "10.259", height: "1.7" }),
        react_1.default.createElement("path", { d: "M10.5,18.692H6.742a6.692,6.692,0,0,1,0-13.384H10.5v1.7H6.742a4.993,4.993,0,0,0,0,9.985H10.5Z" }),
        react_1.default.createElement("path", { d: "M17.258,18.692H13.5v-1.7h3.757a4.993,4.993,0,0,0,0-9.985H13.5v-1.7h3.757a6.692,6.692,0,0,1,0,13.384Z" })));
}
exports.default = LinkIcon;
